'use client'

import { useEffect } from 'react'
import Script from 'next/script'
import { usePathname } from 'next/navigation'

export function AlgoliaSearch() {
  const pathname = usePathname()

  const shouldHideSearch =
    pathname === '/' ||
    pathname?.startsWith('/dashboard') ||
    pathname?.startsWith('/verify-email') ||
    pathname?.startsWith('/sign-in') ||
    pathname?.startsWith('/sign-up') ||
    pathname?.startsWith('/forgot-password') ||
    pathname?.startsWith('/settings') ||
    pathname?.startsWith('/billing') ||
    pathname?.startsWith('/trial-expired') ||
    pathname?.startsWith('/get-started') ||
    pathname?.startsWith('/pricing')

  useEffect(() => {
    // Cleanup function to prevent multiple initializations
    return () => {
      const searchContainer = document.getElementById('search')
      if (searchContainer) {
        searchContainer.innerHTML = ''
      }
    }
  }, [])

  if (shouldHideSearch) {
    return null
  }

  const handleScriptLoad = () => {
    if (typeof window !== 'undefined' && (window as any).SiteSearch) {
      (window as any).SiteSearch.init({
        container: '#search',
        applicationId: 'B7QCQWB48X',
        apiKey: 'd930ba4975882e427f8c84fb54e9e9b6',
        indexName: 'www_authflow_net_b7qcqwb48x_pages',
        attributes: {
          primaryText: 'title',
          secondaryText: 'description',
          tertiaryText: 'keywords',
          url: 'url',
          image: 'image'
        },
        darkMode: false,
      })
    }
  }

  return (
    <>
      <link
        rel="stylesheet"
        href="https://unpkg.com/@algolia/sitesearch@latest/dist/search.min.css"
      />
      <Script
        src="https://unpkg.com/@algolia/sitesearch@latest/dist/search.min.js"
        strategy="afterInteractive"
        onLoad={handleScriptLoad}
      />
      <div 
        id="search" 
        suppressHydrationWarning 
        style={{
          display: 'flex',
          flexFlow: 'column-reverse',
          margin: '10px'
        }}
      />
    </>
  )
}
